import React, { useEffect, useState } from 'react';
import { Col, Row, Card } from 'react-bootstrap';
import { HVAPOC, getPOCsByGroup } from 'services/hvaagent.service';
import { hvaImagesandVoices } from 'pages/hva/hvaImagesandVoices';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import Button from 'components/base/Button';
import HVAHealthCareContainer from './HealthCare/HVAHealthCareContainer';
import HVADynamicConversationModal from './DebtCollection/HVADynamicConversationModal';
import HVAHellenicCadasterModal from './Cadaster/HVADynamicConversationModal';
import HVAAyvensModal from './Ayvens/HVAAyvensModal';
import greek from 'assets/img/flags/greece.png';

type Language = 'greek';

const HVAPOCGreece = () => {
  const [pocs, setPocs] = useState<HVAPOC[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedPOC, setSelectedPOC] = useState<HVAPOC | null>(null);
  const [showHealthCarePage, setShowHealthCarePage] = useState(false);

  // Aquí cargamos las POCs disponibles
  useEffect(() => {
    const fetchPOCs = async () => {
      try {
        const pocsData = await getPOCsByGroup('greece');
        setPocs(pocsData);
      } catch (error) {
        console.error('Error fetching POCs:', error);
      }
    };
    fetchPOCs();
  }, []);

  const getImagePath = (bxpname: string): string | undefined => {
    return hvaImagesandVoices[bxpname]?.image;
  };

  const languageToFlag: Record<Language, string> = {
    greek: greek
  };

  const handleConversationError = (error: Error) => {
    // Handle conversation errors appropriately
    console.error('Conversation error:', error);
    // To show a toast or notification here
  };

  const handleOpenChat = (poc: HVAPOC) => {
    setSelectedPOC(poc);

    // Si es la POC de Healthcare, mostramos la página en lugar del modal
    if (poc.pocform === 5) {
      setShowHealthCarePage(true);
    } else {
      setShowModal(true);
    }
  };

  const handleCloseChat = () => {
    setSelectedPOC(null);
    setShowModal(false);
    setShowHealthCarePage(false);
  };

  // Si showHealthCarePage es true, mostramos la página de healthcare
  if (showHealthCarePage && selectedPOC) {
    return (
      <div className="position-relative">
        <HVAHealthCareContainer
          title={selectedPOC.title}
          agentCode={selectedPOC.agentcode}
          agentName={selectedPOC.name}
          agentImage={getImagePath(selectedPOC.picture)}
          onError={handleConversationError}
          onClose={handleCloseChat}
          firstName="Giorgos"
          lastName="Papadopoulos"
          amka="12345678901"
          phoneNumber="694 555 1234"
          firstMessage={selectedPOC.firstmessage}
          prompt={selectedPOC.prompt}
          voice={selectedPOC.voice}
          language={selectedPOC.language}
        />
      </div>
    );
  }

  return (
    <>
      <Row className="gy-3 mb-6 justify-content-between">
        <Col>
          <h2 className="mb-2 text-body-emphasis">Greece</h2>
          <h5 className="text-body-tertiary fw-semibold">
            Humanized Virtual Agent (HVA) playground.
          </h5>
        </Col>
      </Row>
      <Row className="d-flex p-0">
        {pocs.map(poc => (
          <Col key={poc.id} xl={12} xxl={6} className="pb-3">
            <Card className="h-100 position-relative">
              <Card.Body className="p-6 pt-2">
                <img
                  src={languageToFlag[poc.flag as Language] || greek}
                  alt="Language"
                  className="position-absolute"
                  style={{ top: '0px', right: '0px' }}
                />
                <Row>
                  <Col>
                    <h3 className="text-body-emphasis pt-5 pb-3">
                      {poc.title}
                    </h3>
                  </Col>
                  <Col
                    sm="auto"
                    xxl="auto"
                    className="d-flex align-items-center justify-content-end pe-6"
                  >
                    {poc.agentcode && (
                      <div className="text-center bg-primary rounded-5 px-3">
                        <Button
                          variant="link"
                          className="p-2 text-decoration-none text-white"
                          onClick={() => handleOpenChat(poc)}
                        >
                          {`Test ${poc.name}`}
                          <FontAwesomeIcon
                            icon={faChevronRight}
                            className="px-1 pe-0"
                          />
                        </Button>
                      </div>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col
                    sm="auto"
                    xxl="auto"
                    className="d-flex align-items-center justify-content-center p-4 pt-1 pb-0"
                  >
                    {getImagePath(poc.picture) ? (
                      <img
                        src={getImagePath(poc.picture)}
                        alt={`${poc.name}`}
                      />
                    ) : (
                      <p>Image not found</p>
                    )}
                  </Col>
                  <Col className="d-flex flex-column p-4 fs-9 lh-sm pb-0">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: poc.description
                      }}
                    />
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {selectedPOC && (
        <>
          {selectedPOC.pocform === 1 && (
            <HVADynamicConversationModal
              show={showModal}
              onHide={handleCloseChat}
              title={selectedPOC.title}
              agentCode={selectedPOC.agentcode}
              agentName={selectedPOC.name}
              agentImage={getImagePath(selectedPOC.picture)}
              onError={handleConversationError}
              customer="Stefanos Adetokoubo"
              trn="456123987"
              dateOfBirth={new Date('1980-11-13')}
              debtamount={327}
              currency="EUR"
              origin="Unpaid loan installments from October and November plus delinquency interest"
              IBAN="GR16 0110 1050 0025 4801 2345 678"
              firstMessage={selectedPOC.firstmessage}
              prompt={selectedPOC.prompt}
              voice={selectedPOC.voice}
              language={selectedPOC.language}
              maxDiscount={10}
            />
          )}

          {selectedPOC.pocform === 6 && (
            <HVAHellenicCadasterModal
              show={showModal}
              onHide={handleCloseChat}
              title={selectedPOC.title}
              agentCode={selectedPOC.agentcode}
              agentName={selectedPOC.name}
              agentImage={getImagePath(selectedPOC.picture)}
              onError={handleConversationError}
              customer="Stefanos Adetokoubo"
              trn="456123987"
              dateOfBirth={new Date('1980-11-13')}
              debtamount={327}
              currency="EUR"
              origin="Unpaid loan installments from October and November plus delinquency interest"
              IBAN="GR16 0110 1050 0025 4801 2345 678"
              firstMessage={selectedPOC.firstmessage}
              prompt={selectedPOC.prompt}
              voice={selectedPOC.voice}
              language={selectedPOC.language}
            />
          )}

          {selectedPOC.pocform === 7 && (
            <HVAAyvensModal
              show={showModal}
              onHide={handleCloseChat}
              title={selectedPOC.title}
              agentCode={selectedPOC.agentcode}
              agentName={selectedPOC.name}
              agentImage={getImagePath(selectedPOC.picture)}
              onError={handleConversationError}
              customer="Kostas Makridis"
              licensePlate="XYZ1234"
              mileage={29580}
              tireSize="205/55R16"
              serviceHistory="Due for 2nd Service and Emissions Card renewal"
              preferredArea="Western suburbs"
              contactPhone="694 555 1234"
              firstMessage={selectedPOC.firstmessage}
              prompt={selectedPOC.prompt}
              voice={selectedPOC.voice}
              language={selectedPOC.language}
            />
          )}
        </>
      )}
    </>
  );
};

export default HVAPOCGreece;
